import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CompteService } from "src/app/suivi-portefeuille/core/service/compte.service";
import { DossierService } from "src/app/suivi-portefeuille/core/service/dossier.service";
import { Dossier } from "src/app/suivi-portefeuille/core/model/dossier";

interface Alert {
  type: string;
  message: string;
}

@Component({
  selector: "app-dossier-tab",
  templateUrl: "./dossier-tab.component.html",
  styleUrls: ["./dossier-tab.component.scss"],
})
export class DossierTabComponent implements OnInit {
  alerts: Alert[] = [];

  dossiers: Dossier[];

  codeClient: String;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _dossierService: DossierService,
    private _compteService: CompteService
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.codeClient = params["codeClient"];
      this.getDossiersByCodeClient(this.codeClient);
    });
  }

  getDossiersByCodeClient(codeclient) {
    this._dossierService.getDossiersByCodeClient(codeclient).subscribe(
      (data) => {
        this.dossiers = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  voirEcheance(numDossier): void {
    this._router.navigate(["/suivi-portefeuille/detail-dossier/" + numDossier]);
  }

  close(alert: Alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }
}
